import React from 'react';
import { withTranslation } from 'react-i18next';
import ListLinkBoxOption from './ListLinkBoxOption';

const ListLinkBox = (props) => {
    return (
        <div className="row">
            {
                props.options.map((i, index) =>
                    <ListLinkBoxOption key={i.id ? i.id : `lb${index}`}
                        route={i.route}
                        data={i.data}
                        icon={i.icon}
                        text={i.text}
                        onClick={i.onClick}
                    />
                )
            }
        </div>
    );
};

export default withTranslation()(ListLinkBox);
